import React from "react"
import {useAppContextState} from "app/@hooks";
import {createContext} from "use-context-selector";

const Context = createContext({})

const initialState = {
    isOpenModal: null, hotelName: null, chartData: [],
    hotelsKeys: [], isLoadingTable: true, isLoadingChart: true,
    priceByNight: false, tableData: [], avgDates: {}, dateSelected: null
}

export function CompetitionAnalyzerPriceEvolutionProvider({children}) {
    const { state, replaceState, updateState } = useAppContextState(initialState)

    return <Context.Provider value={{state, replaceState, updateState}}>
        {children}
    </Context.Provider>
}

export default Context